<template>

  <div class="material-select" :class="isSmall? 'material-select--small':''">

    <div class="material-select__holder">
      <div class="material-select__title" @click="isOpen = !isOpen">{{showTitle}} <div class="material-select__state" :class="isOpen? 'material-select__state--open':''"></div></div>

      <div class="material-select__search" :class="isOpen? '':'hide'" v-if="allowSearch">
        <input type="text" class="material-select__search-input" v-model="searchString">
        <a href="#" @click.prevent="closeSearchBox()" class="material-select__search__close"></a>
      </div>

      <div class="material-select__values" v-if="isMulti" :class="isOpen? '':'hide'">

        <div v-for="val in possibleValues">
          <input type="checkbox" class="material-select__checkbox" :id="val.id" name="selected-variant" :value="val.id" v-model="checkedVariants">
          <label :for="val.id" class="material-select__label material-select__label--checkbox">{{val.title}}</label>
        </div>

      </div>

      <div class="material-select__values" v-if="!isMulti" :class="isOpen? '':'hide'">
        <div v-for="val in possibleValuesFiltered">
          <input type="radio" class="material-select__checkbox" :id="id+'_'+val.id" name="selected-variant" :value="val.id" v-model="checkedVariants">
          <label :for="id+'_'+val.id" class="material-select__label material-select__label--radio">{{val.title}}</label>
        </div>
      </div>

      <div class="material-select__selected-values" v-if="isMulti">
        <div class="material-select__selected-value" v-for="val in checkedVariants">
          {{possibleValuesMapped[val]}}
          <label :for="val" >X</label>
        </div>
      </div>

    </div>

  </div>


</template>

<style type="text/css" lang="less">
  .material-select{

    &__checkbox{
      position: absolute;
      left: -9999px;
      visibility: hidden;

      &:checked+.material-select__label--checkbox::before{
        background-position: 0 -64px;
      }
    }

    &__title{
      display: inline-block;
      height: 32px;
      line-height: 32px;
      background: #FFFFFF;
      border: 1px solid #97A2C4;
      border-radius: 3px;
      font-size: 14px;
      color: #3F6FA7;
      padding: 0 32px 0 24px;
      min-width: 200px;
      position: relative;
    }

    &__state{
      position: absolute;
      top: 14px;
      right: 10px;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 6px 4px 0 4px;
      border-color: #3f6fa7 transparent transparent transparent;

      &--open{
        transform: rotate(180deg);
      }
    }

    &__holder{
      position: relative;
      display: inline-block;

    }

    &__values{
      position: absolute;
      max-width: 250px;
      top:40px;
      padding: 16px 24px 16px 12px;
      box-sizing: border-box;
      background: #FFFFFF;
      box-shadow: 5px 5px 23px 0 rgba(0,0,0,0.31);
      border-radius: 3px;
      z-index: 100;
      max-height: 200px;
      overflow-y: scroll;
    }

    &__label{
      display: block;
      position: relative;
      margin-bottom: 10px;
      font-size: 16px;

      &--checkbox{
        padding-left: 24px;

        &::before{
          position: absolute;
          content: "";
          left: 0;
          top:2px;
          width: 18px;
          height: 18px;
          background: url("/static/checkbox.svg") 0 0 no-repeat;
        }
      }
    }

    &__selected-values{
      padding: 20px 0;
    }

    &__selected-value{
      display: inline-block;
      margin: 0 5px 5px;
      height: 32px;
      white-space: nowrap;
      line-height: 32px;

      /* Rectangle: */
      background: #FAE0DA;
      border-radius: 100px;

      font-size: 14px;
      color: #464545;
      padding: 0 15px;
    }


    &__search{
      position: absolute;
      top:0;
      left:0;
      right: 0;
      bottom: 0;

      &-input{
        display: block;
        width: 100%;
        height: 100%;
        outline: none;
        padding: 10px;
      }

      &__close {
        width: 30px;
        height: 30px;
        position: absolute;
        top: 50%;
        right: 2px;
        font-size: 0;
        display: inline-block;
        margin-top: -10px;

        &::after, &::before {
          position: absolute;
          content: '';
          width: 15px;
          height: 1px;
          background: #3F6FA7;
          left: 50%;
          top: 50%;
          transform: rotate(45deg);
          margin-top: -5px;
          margin-left: -5px;
        }

        &::before {
          transform: rotate(-45deg);
        }
      }
    }

  }

  .material-select--small{
    .material-select__title{
      height: 20px;
      line-height: 20px;
      min-width: auto;
      font-size: 12px;
    }

    .material-select__state{
      top: 8px;
    }

    .material-select__values{
      top:20px;
    }
  }


</style>


<script type="text/javascript">
  export default {
    name: 'material-select',
    props: {
      isMulti: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        default: 'Выберите...',
      },
      possibleValues: {
        type: Array,
        default() { return []; },
      },
      selectedValues: {
        type: [Array, String],
        default() { return []; },
        required: false,
      },
      isSmall: {
        type: Boolean,
        default: false,
      },
      allowSearch: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      closeSearchBox() {
        this.isOpen = false;
      },
    },
    watch: {
      selectedValues(input) {
        this.checkedVariants = input;
      },
      checkedVariants(input) {
        if (!this.isMulti) {
          this.isOpen = false;
        }
        this.$emit('select', input);
      },
      possibleValues() {
        this.checkedVariants = this.selectedValues;
      },
    },
    computed: {
      showTitle() {
        if (!this.isMulti && this.checkedVariants.length > 0) {
          if (this.possibleValues.filter(val => (val.id === this.checkedVariants))[0] !== undefined) {
            return this.possibleValues.filter(val => (val.id === this.checkedVariants))[0].title;
          }
        }
        return this.title;
      },
      possibleValuesMapped() {
        return Object.assign(...this.possibleValues.map(
          o => ({ [o.id]: o.title }),
        ));
      },
      possibleValuesFiltered() {
        return this.possibleValues.filter(value => (this.searchString === '' || value.title.toUpperCase().includes(this.searchString.toUpperCase())));
      },
    },
    data() {
      return {
        id: Math.random(),
        isOpen: false,
        checkedVariants: this.selectedValues,
        searchString: '',
      };
    },
  };
</script>


// WEBPACK FOOTER //
// SelectMaterial.vue?5e5837a5